import React from "react";
import { DappContextProvider } from "../../contexts/MintContext";

// TODO: Make this a "logout" button
export function ConnectedWallet({address}: {address: string}): React.ReactElement | null {
  const { disconnectWallet } = React.useContext(DappContextProvider);
  if(!address) {
    // an issue with function components re-rendering before setState is complete,
    // by the time this component gets called, the "address" might be undefined
    return null;
  }
  
  return (
    <div className="connect-wallet-button-wrapper">
      <button
        className="connected-wallet-button"
        type="button"
        title={address}
        onClick={ disconnectWallet }
        >
        Disconnect
      </button>
    </div>
  );
}
